module.exports = __webpack_public_path__ + "img/slide-9-2.f2e3c2ed.jpg";